export const BANK_ACCOUNT_CHECKSUM_ERROR =
  'Проверьте расчётный счёт: номер не сходится с БИК банка — похоже на опечатку';

/**
 * Контрольное число счёта по алгоритму Банка России (как bank-account-checksum.util на бэке):
 * 3 последние цифры БИК + 20 цифр счёта, веса 7-1-3, сумма делится на 10. null — неполные данные.
 */
export function isBankAccountChecksumValid(
  bik: string | null | undefined,
  account: string | null | undefined,
): boolean | null {
  const bikDigits = (bik ?? '').replace(/\D/g, '');
  const accountDigits = (account ?? '').replace(/\D/g, '');
  if (bikDigits.length !== 9 || accountDigits.length !== 20) return null;
  const digits = bikDigits.slice(-3) + accountDigits;
  const weights = [7, 1, 3];
  let sum = 0;
  for (let i = 0; i < digits.length; i++) sum += Number(digits[i]) * weights[i % 3];
  return sum % 10 === 0;
}
